import React, { useState, useEffect, useContext } from "react";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import axios from "axios";
import { count } from "console";
import fileDownload from "js-file-download";
import moment from "moment";
import { fetchAuthToken } from "../../Helpers/Network/OAuthHandler";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import userRole from "../../Redux/Reducers/userRole";
import "./allStyle.css";
import {
  Button,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { json } from "stream/consumers";
import { SanjeevaniModules } from "../../Helpers/Enums/Modules";
import {
  FinalSettlementDataBySetId,
  DownloadFinalSettlementData,
  SendEmailFinalSettlementData,
  UpdateApprovalSettlementRequest,
} from "../../Helpers/APIEndPoints/EndPoints";
import { RiFileListLine } from "react-icons/ri";
import ButtonComponent from "../../Components/ButtonForm/Button";
import FinalsettlementModal from "./ApprovalModal/FinalsettlementModal";
import { APICall } from "../../Helpers/Network/APICalls";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { MODES } from "../../Helpers/Enums/Enum";
import { SettlementReqStatus } from "../../Helpers/Enums/ApplicationStatus";
import BaseModal from "../../Components/BaseModel/BaseModel";
import { useNavigate } from "react-router-dom";

const FinalSettlementGrid = (props) => {
  const context = getContext();
  const navigate = useNavigate();
  const { showLoader, hideLoader, loader } = useContext(LoaderContext);
  const [dashboardData, setDashboardData] = useState([]);
  const [dashboardDatarecovery, setDashboardDataRecovery] = useState([]);
  const [count, setCount] = useState(0);
  const [reCount, setReCount] = useState(0);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const [sendMemberId, setSendMemberId] = useState(0);
  const [pdfBytes, setPdfBytes] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [start, setStart] = useState(0);
  const [reStart, setReStart] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalOpen2, setModalOpen2] = useState(false);
  const [confirmValue, setConfirmValue] = useState("");
  const [TotalAmountDemand, SetTotalAmountDemand] = useState(0);
  const [TotalAmountRecovery, SetTotalAmountRecovery] = useState(0);
  const pageSize = 15;

  const StateCurrentStatus = props.statecurrentstatus;
  const StateSetId = props.statesetid;
  const StateMemberId = props.statememberid;
  const StateMode = props?.mode;

  const GridColumns = [
    // {
    //   name: "AccdId",
    //   label: "ACCD",
    //   options: {
    //     sort: false,
    //     display: true,
    //   },
    // },
    {
      name: "Payable",
      label: "PAYABLE",
      options: {
        sort: false,
        display: true,
        width: "100px",
      },
    },
    {
      name: "Amount",
      label: "Amount",
      options: {
        sort: false,
        display: true,
      },
    },
  ];

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    onChangeRowsPerPage: () => {},
    onColumnSortChange: async () => {},
    customRowRender: (data, dataIndex, rowIndex) => {
      return (
        <TableRow>
          {data.map((item, index) => (
            <TableCell key={index}>{item}</TableCell>
          ))}
        </TableRow>
      );
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const Options2 = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    onChangeRowsPerPage: () => {},
    customRowRender: (data, dataIndex, rowIndex) => {
      return (
        <TableRow>
          {data.map((item, index) => (
            <TableCell key={index}>{item}</TableCell>
          ))}
        </TableRow>
      );
    },
    onChangePage: async (page) => {
      setReStart(page * pageSize);
    },
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    let eventData = event.currentTarget;
    setAnchorEl(eventData);
  };

  useEffect(() => {
    fetchDashboardData();
    fetchDashboardData2();
  }, [start, reStart]);

  const fetchDashboardData = async () => {
    SetTotalAmountDemand(0);
    
    showLoader();
    try {
      let obj = {
        StartingLimit: start,
        ResultsPerPage: pageSize,
        SetId: StateSetId,
        MemberId: StateMemberId,
        Type: "DEMANDS",
      };

      const response2 = await APICall(FinalSettlementDataBySetId, obj);
      if (response2.Status === ApiStatus.OK) {
        setDashboardData(response2?.Data);
        setCount(
          response2?.Data?.[0]?.TotalCount || response2?.Data?.length || 0
        );
        // Capture TotalAmount from the first row
        SetTotalAmountDemand(response2?.Data?.[0]?.TotalAmount || 0);
      }
      hideLoader();
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetchDashboardData2 = async () => {
    SetTotalAmountRecovery(0);
    
    showLoader();
    try {
      let obj = {
        StartingLimit: reStart,
        ResultsPerPage: pageSize,
        SetId: StateSetId,
        MemberId: StateMemberId,
        Type: "RECOVERIES",
      };
      const response2 = await APICall(FinalSettlementDataBySetId, obj);
      if (response2.Status === ApiStatus.OK) {
        setDashboardDataRecovery(response2?.Data);
        setReCount(
          response2?.Data?.[0]?.TotalCount || response2?.Data?.length || 0
        );
        // Capture TotalAmount from the first row
        SetTotalAmountRecovery(response2?.Data?.[0]?.TotalAmount || 0);
      }
      hideLoader();
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const DownloadFunction = async () => {
    showLoader();
    let requestParams = {
      MemberId: StateMemberId,
      //Id: StateSetId,
    };
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: DownloadFinalSettlementData,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        // setPdfBytes(response.data);
        fileDownload(
          response.data,
          `FinalSettlementForm_` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.pdf`
        );
        // var blob = new Blob([response.data], { type: "application/pdf" });
        // var url = URL.createObjectURL(blob);
        // setPdfUrl(url);
      })
      .catch((error) => {
        notify(ToastType.Error, error);
       
      })
      .finally(() => hideLoader());
  };
  const SendEmailFinalSettlement = async () => {
    showLoader();
    try {
      let obj = {
        MemberId: StateMemberId,
      };
      const response2 = await APICall(SendEmailFinalSettlementData, obj);
      if (response2.Status === ApiStatus.OK) {
        notify(ToastType.Success, response2.Message);
      }
      hideLoader();
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const handleCloseModal = async (value = "NO") => {
    setConfirmValue(value);
    setModalOpen(false);
    if (value == "NO") {
      isModalOpen2 == true ? setModalOpen2(false) : setModalOpen2(true);
    } else {
      isModalOpen2 == true ? setModalOpen2(false) : setModalOpen2(true);
    }
  };

  const submitApprovalReject = async () => {
    showLoader();
    // alert(confirmValue);
    // let Status = SettlementReqStatus.Settlement_Rejected;
    // if (confirmValue === "YES") {
    //let Status = SettlementReqStatus.FinalSettlementApprovalPending;
    let Status = SettlementReqStatus.Settlement_Approved2;
    // }

    let param = {
      MemberId: StateMemberId,
      Id: StateSetId,
      RoleId: context.CurrentRoleId,
      StatusId: Status,
      Comment: "",
      Approver: context?.Id,
      CreatedBy: context?.Id,
      ModifiedBy: context?.Id,
      DocumentDetailId: 0,
      IsActive: true,
    };
    const res = await APICall(UpdateApprovalSettlementRequest, param);

    if (res.Status === ApiStatus.OK) {
      
      if (res.Message.toLocaleLowerCase() === "Ok".toLocaleLowerCase()) {
        let mesaage = "";

        // if (Status == SettlementReqStatus.Settlement_Approved2) {
        mesaage = "approved";
        // }

        // if (Status == SettlementReqStatus.Settlement_Rejected) {
        //   mesaage = "rejected";
        // }

        notify(ToastType.Success, `Request ${mesaage} Successfully.`);
        // confirmValue
        handleCloseModal();
        navigate("/SettlementRequestDashboard");
        hideLoader();
      }
      hideLoader();
    } else {
      notify(ToastType.Error, res.Message);
      hideLoader();
    }
  };

  // const ModalDesign = () => {
  //   return (
  //     <>
  //       <div className={"ModalSize"}>
  //         <label
  //           className="d-block"
  //           style={{
  //             fontWeight: "bold",
  //             marginBottom: "10px",
  //             fontFamily: "var(--bs-body-font-family)",
  //             fontSize: "var(--bs-body-font-size)",
  //           }}
  //         >
  //           Approve or Reject settlement?
  //         </label>

  //         <div className="row justify-content-end no-gutters">
  //           <div className="col-auto">
  //             <button
  //               onClick={() => handleCloseModal("NO")}
  //               className="btn btn-secondary btn-sm mx-2"
  //             >
  //               Reject
  //             </button>
  //           </div>
  //           <div className="col-auto">
  //             <button
  //               onClick={() => handleCloseModal("YES")}
  //               id={"saveBtn"}
  //               className="btn btn-secondary btn-sm"
  //             >
  //               Accept
  //             </button>
  //           </div>
  //         </div>
  //       </div>
  //     </>
  //   );
  // };
  const SecondModalDesign = () => {
    return (
      <>
        <div className={"ModalSize"}>
          <label
            className="d-block"
            style={{
              fontWeight: "bold",
              marginBottom: "10px",
              fontFamily: "var(--bs-body-font-family)",
              fontSize: "var(--bs-body-font-size)",
            }}
          >
            {/* {confirmValue == "YES" */}
            Confirm settlement acceptance
            {/* : "Confirm settlement rejection?"} */}
          </label>

          <div className="row justify-content-end no-gutters">
            <div className="col-auto">
              <button
                onClick={() => setModalOpen2(false)}
                className="btn btn-secondary btn-sm mx-2"
              >
                No
              </button>
            </div>
            <div className="col-auto">
              <button
                onClick={submitApprovalReject}
                id={"saveBtn"}
                className="btn btn-secondary btn-sm"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      <div className="row">
        <div className="col-lg-12">
          <DynamicGrid
            options={Options}
            data={dashboardData}
            columns={GridColumns}
          />
          <div className="TatolAmt">
            <label>Total : </label>
            <input
              type="text"
              value={TotalAmountDemand}
              disabled
              className="form-control "
            />
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-lg-12">
          <h3>RECOVERIES</h3>
          <DynamicGrid
            options={Options2}
            data={dashboardDatarecovery}
            columns={GridColumns}
          />
          <div className="TatolAmt">
            <label>Total : </label>
            <input
              type="text"
              value={TotalAmountRecovery}
              disabled
              className="form-control"
            />
          </div>
        </div>
        <div className="col-lg-12 TatolAmt">
          <label htmlFor="net-payable" style={{ color: "#01a71d" }}>
            Net Payable:
          </label>
          <input
            type="text"
            id="net-payable"
            value={TotalAmountDemand - TotalAmountRecovery}
            disabled
            className="form-control"
          />
        </div>
      </div>
      {StateMode === MODES.EDIT && (
        <div className="mt-5 d-flex justify-content-end">
          <div className="pt-2  dwnl">
            <div className="form-group">
              <button
                className="btn btn-submit"
                onClick={() => {
                  DownloadFunction();
                }}
              >
                Download
              </button>
            </div>
          </div>
          <div className="pt-2" style={{ marginLeft: "10px" }}>
            <div className="form-group">
              <button
                className="btn btn-submit"
                onClick={() => {
                  SendEmailFinalSettlement();
                }}
              >
                Send Mail
              </button>
            </div>
          </div>
          <div className="pt-2  ">
            <div className="form-group">
              {StateCurrentStatus == SettlementReqStatus.Settlement_Approved ? (
                <>
                  <ButtonComponent
                    icon={"RiFileListLine"}
                    value={"Settlement"}
                    style={{ marginLeft: "10px" }}
                    id={"saveBtn"}
                    onClick={() => setModalOpen2(!isModalOpen2)}
                  >
                    <RiFileListLine />
                  </ButtonComponent>
                </>
              ) : (
                <>
                  <ButtonComponent
                    icon={"RiFileListLine"}
                    value={"Verify"}
                    style={{ marginLeft: "10px" }}
                    id={"saveBtn"}
                    onClick={handleClick}
                  >
                    <RiFileListLine />
                  </ButtonComponent>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* <BaseModal
        buttonText={""}
        open={isModalOpen}
        content={<ModalDesign />}
        onclose={handleCloseModal}
      /> */}
      <BaseModal
        buttonText={""}
        open={isModalOpen2}
        content={<SecondModalDesign />}
        onclose={handleCloseModal}
      />

      <FinalsettlementModal
        open={open}
        anchorEl={anchorEl}
        handleClose={handleClose}
        module={SanjeevaniModules.ModuleApproval}
        // appModule={appModule}
        Id={StateSetId}
        ReqMemberId={StateMemberId}
      />
    </div>
  );
};

export default FinalSettlementGrid;
